<div class="z-40 shadow-sm" [ngClass]="{ 'dark text-white-dark': store.semidark && store.menu === 'horizontal'}">
    <div class="relative flex w-full min-h-11 sm:min-h-12 items-center justify-between gap-2 border-b border-black/[0.08] bg-white px-3 sm:px-5 py-1.5 sm:py-2 dark:border-[#253b5c] dark:bg-[#0e1726]">
         @if (!isOnboardingRoute && !isAuthRoute) {
        @if(user$ | async; as user){ <div
            class="horizontal-logo flex shrink-0 items-center lg:hidden ltr:mr-1.5 rtl:ml-1.5">
            <a routerLink="/" class="main-logo flex shrink-0 items-center">
                <img class="inline h-7 w-7 ltr:-ml-1 rtl:-mr-1" src="/assets/images/sc.svg" alt="" />
            </a>
        </div>}
    }

        <div class="flex flex-1 min-w-0 items-center dark:text-[#d0d2d6]">
            @if (user$ | async; as user) {
                @if (!isOnboardingRoute) {
                    @if (!isAuthRoute) {
                    <div class="sm:ltr:mr-auto sm:rtl:ml-auto">
                        <form
                            class="absolute inset-x-0 top-1/2 z-10 mx-4 hidden -translate-y-1/2 sm:relative sm:top-0 sm:mx-0 sm:block sm:translate-y-0"
                            [ngClass]="{ '!block': search }" (submit.prevent)="search = false">
                            <div class="relative">
                                <input type="text"
                                    class="peer form-input bg-gray-100 placeholder:tracking-widest sm:bg-transparent ltr:pl-9 ltr:pr-9 ltr:sm:pr-4 rtl:pl-9 rtl:pr-9 rtl:sm:pl-4"
                                    placeholder="{{'search' | translate}}" />
                                <button type="button"
                                    class="absolute inset-0 h-9 w-9 appearance-none peer-focus:text-primary ltr:right-auto rtl:left-auto">
                                    <icon-search class="mx-auto" />
                                </button>
                            </div>
                        </form>

                        <button type="button"
                            class="search_btn rounded-full bg-white-light/40 p-1.5 hover:bg-white-light/90 dark:bg-dark/40 dark:hover:bg-dark/60 sm:hidden"
                            (click)="search = !search">
                            <icon-search class="mx-auto h-4 w-4 dark:text-[#d0d2d6]" />
                        </button>
                    </div>
                    } @else {
                    <ng-container *ngTemplateOutlet="onboardingHeaderLogo"></ng-container>
                    }
                } @else {
                    <ng-container *ngTemplateOutlet="onboardingHeaderLogo"></ng-container>
                }
            }@else {
            @if (isOnboardingRoute) {
                <ng-container *ngTemplateOutlet="onboardingHeaderLogo"></ng-container>
            } @else {
            <div class="flex items-center justify-start min-w-0 shrink">
                <a routerLink="/" class="main-logo flex shrink-0 items-center max-w-full">
                    <img class="inline h-7 sm:h-9 w-auto max-w-[110px] sm:max-w-[180px] object-contain ltr:-ml-1 rtl:-mr-1" src="/assets/images/logo.svg" alt="" />
                </a>
            </div>
            }

            @if (!isOnboardingRoute) {
            <!-- Center links when no user -->
            <div class="hidden sm:flex items-center justify-center flex-1 space-x-6  md:pr-5">
                <a href="https://suknacapital.com/about-us"
                    class="text-gray-700 hover:text-primary dark:text-gray-300 dark:hover:text-white transition-colors text-center"
                    target="_blank">
                    {{"aboutUs" | translate}}
                </a>

                <!-- Funds Dropdown -->
                <div class="dropdown shrink-0 relative" (mouseenter)="showFundsDropdown = true"
                    (mouseleave)="showFundsDropdown = false">
                    <button type="button"
                        class="text-gray-700 hover:text-primary dark:text-gray-300 dark:hover:text-white transition-colors flex items-center text-center">
                        {{"funds" | translate}}
                        <icon-caret-down class="ml-1 h-3 w-3" />
                    </button>
                    <ul *ngIf="showFundsDropdown" @toggleAnimation
                        class="absolute top-8 w-[200px] !py-2 font-semibold text-dark dark:text-white-dark dark:text-white-light/90 bg-white dark:bg-[#1b2e4b] shadow-lg rounded-md border border-gray-200 dark:border-gray-600 z-50">
                        <li>
                            <a href="https://suknacapital.com/funds"
                                class="flex items-center w-full px-3 py-2 text-sm hover:bg-gray-50 dark:hover:bg-gray-700 rounded-md transition-colors"
                                target="_blank">
                                {{"directFinancing" | translate}}
                            </a>
                        </li>
                        <li>
                            <a href="https://suknaventures.com/"
                                class="flex items-center w-full px-3 py-2 text-sm hover:bg-gray-50 dark:hover:bg-gray-700 rounded-md transition-colors"
                                target="_blank">
                                {{"suknaVentures" | translate}}
                            </a>
                        </li>
                    </ul>
                </div>

                <a href="https://suknacapital.com/media"
                    class="text-gray-700 hover:text-primary dark:text-gray-300 dark:hover:text-white transition-colors text-center"
                    target="_blank">
                    {{"media" | translate}}
                </a>
            </div>

            <!-- Mobile Menu Dropdown -->
            @if(showMobileMenu){<div
                class="sm:hidden absolute top-full left-0 right-0 bg-white dark:bg-[#0e1726] shadow-lg border-t border-gray-200 dark:border-gray-700 z-40">
                <div class="flex flex-col space-y-2 p-4">
                    <a href="https://suknacapital.com/about-us"
                        class="text-gray-700 hover:text-primary dark:text-gray-300 dark:hover:text-white transition-colors py-2 px-3 rounded-md hover:bg-gray-50 dark:hover:bg-gray-800"
                        target="_blank" (click)="showMobileMenu = false">
                        {{"aboutUs" | translate}}
                    </a>

                    <!-- Mobile Funds Section -->
                    <div class="border-t border-gray-200 dark:border-gray-700 pt-2">
                        <button type="button"
                            class="w-full text-left text-gray-700 hover:text-primary dark:text-gray-300 dark:hover:text-white transition-colors py-2 px-3 rounded-md hover:bg-gray-50 dark:hover:bg-gray-800 flex items-center justify-between"
                            (click)="showMobileFunds = !showMobileFunds">
                            {{"funds" | translate}}
                            <icon-caret-down class="h-4 w-4 transform transition-transform"
                                [ngClass]="{'rotate-180': showMobileFunds}" />
                        </button>
                        <div *ngIf="showMobileFunds" class="ml-4 mt-2 space-y-1">
                            <a href="https://suknacapital.com/funds"
                                class="block text-gray-600 hover:text-primary dark:text-gray-400 dark:hover:text-white transition-colors py-2 px-3 rounded-md hover:bg-gray-50 dark:hover:bg-gray-800"
                                target="_blank" (click)="showMobileMenu = false">
                                {{"directFinancing" | translate}}
                            </a>
                            <a href="https://suknaventures.com/"
                                class="block text-gray-600 hover:text-primary dark:text-gray-400 dark:hover:text-white transition-colors py-2 px-3 rounded-md hover:bg-gray-50 dark:hover:bg-gray-800"
                                target="_blank" (click)="showMobileMenu = false">
                                {{"suknaVentures" | translate}}
                            </a>
                        </div>
                    </div>

                    <a href="https://suknacapital.com/media"
                        class="text-gray-700 hover:text-primary dark:text-gray-300 dark:hover:text-white transition-colors py-2 px-3 rounded-md hover:bg-gray-50 dark:hover:bg-gray-800"
                        target="_blank" (click)="showMobileMenu = false">
                        {{"media" | translate}}
                    </a>
                </div>
            </div>}
            }
            }
        </div>

        <div class="flex shrink-0 items-center gap-1 sm:gap-2 ltr:ml-auto rtl:mr-auto">
                <div class="dropdown shrink-0">
                    <div hlMenu>
                        <button type="button" hlMenuButton
                            class="group relative flex items-center rounded-full bg-white-light/40 p-1.5 sm:p-2 hover:bg-white-light/90 hover:text-primary dark:bg-dark/40 dark:hover:bg-dark/60 transition-all duration-200">
                            @if (store.theme === 'light') {
                            <span class="text-gray-500">
                                <icon-sun class="h-4 w-4 sm:h-5 sm:w-5" />
                            </span>
                            } @else if (store.theme === 'dark') {
                            <span class="text-gray-500">
                                <icon-moon class="h-4 w-4 sm:h-5 sm:w-5" />
                            </span>
                            } @else if (store.theme === 'system') {
                            <span class="text-gray-500">
                                <icon-laptop class="h-4 w-4 sm:h-5 sm:w-5" />
                            </span>
                            }
                            <!-- <span class="ml-1 rtl:mr-1 text-xs font-medium text-gray-600 dark:text-gray-300">
                                {{ store.theme?.toLowerCase() | translate | titlecase}}
                            </span> -->
                        </button>
                        <ul *hlMenuItems @toggleAnimation
                            class="top-11 w-[160px] !py-2 font-semibold text-dark dark:text-white-dark dark:text-white-light/90 ltr:right-0 rtl:left-0">
                            <li
                                class="px-2 py-1 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide">
                                {{"themeMode" | translate }}
                            </li>
                            <li class="border-t border-gray-100 dark:border-gray-600 my-1"></li>
                            <li>
                                <button *hlMenuItem="let menuItem" (click)="toggleTheme('light')"
                                    class="flex items-center w-full px-3 py-2 text-sm hover:bg-gray-50 dark:hover:bg-gray-300 rounded-md transition-colors"
                                    [class.bg-gray-50]="store.theme === 'light'"
                                    [class.text-gray-600]="store.theme === 'light'"
                                    [class.dark:bg-blue-900/20]="store.theme === 'light'">
                                    <icon-sun class="h-4 w-4 mr-3 rtl:ml-3 text-gray-500" />
                                    {{"light" | translate }}
                                    @if (store.theme === 'light') {
                                    <span class="ml-auto   text-gray-600">
                                        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                            <path fill-rule="evenodd"
                                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                clip-rule="evenodd" />
                                        </svg>
                                    </span>
                                    }
                                </button>
                            </li>
                            <li>
                                <button *hlMenuItem="let menuItem" (click)="toggleTheme('dark')"
                                    class="flex items-center w-full px-3 py-2 text-sm hover:bg-gray-50 dark:hover:bg-gray-300 rounded-md transition-colors"
                                    [class.bg-gray-50]="store.theme === 'dark'"
                                    [class.text-gray-600]="store.theme === 'dark'"
                                    [class.dark:bg-blue-900/20]="store.theme === 'dark'">
                                    <icon-moon class="h-4 w-4 mr-3 rtl:ml-3 text-gray-500" />
                                    {{"dark" | translate }}
                                    @if (store.theme === 'dark') {
                                    <span class="ml-auto   text-gray-600">
                                        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                            <path fill-rule="evenodd"
                                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                clip-rule="evenodd" />
                                        </svg>
                                    </span>
                                    }
                                </button>
                            </li>
                            <li>
                                <button *hlMenuItem="let menuItem" (click)="toggleTheme('system')"
                                    class="flex items-center w-full px-3 py-2 text-sm hover:bg-gray-50 dark:hover:bg-gray-300 rounded-md transition-colors"
                                    [class.bg-gray-50]="store.theme === 'system'"
                                    [class.text-gray-600]="store.theme === 'system'"
                                    [class.dark:bg-blue-900/20]="store.theme === 'system'">
                                    <icon-laptop class="h-4 w-4 mr-3 rtl:ml-3 text-gray-500" />
                                    {{"system" | translate }}
                                    @if (store.theme === 'system') {
                                    <span class="ml-auto   text-gray-600">
                                        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                            <path fill-rule="evenodd"
                                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                clip-rule="evenodd" />
                                        </svg>
                                    </span>
                                    }
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>

                <!-- <div class="dropdown shrink-0">
                    <div hlMenu>
                        <button type="button" hlMenuButton
                            class="block rounded-full bg-white-light/40 p-2 hover:bg-white-light/90 hover:text-primary dark:bg-dark/40 dark:hover:bg-dark/60">
                                {{ store.locale === 'sa' ? 'AR' : store.locale.toUpperCase() }}
                        </button>
                        <ul *hlMenuItems @toggleAnimation
                            class="top-11 grid w-[280px] grid-cols-2 gap-2 !px-2 font-semibold text-dark dark:text-white-dark dark:text-white-light/90 ltr:-right-14 sm:ltr:-right-2 rtl:-left-14 sm:rtl:-left-2">
                            @for (item of store.languageList; track item) {
                            <li>
                                <button *hlMenuItem="let menuItem" type="button" class="w-full hover:text-primary"
                                    [ngClass]="{ 'bg-primary/10 text-primary': translate.getCurrentLang() === item.code }"
                                    (click)="changeLanguage(item)">
                                    <span class="ltr:ml-3 rtl:mr-3">{{ item.name }}</span>
                                </button>
                            </li>
                            }
                        </ul>
                    </div>
                </div> -->

                @if (user$ | async; as user) {
                @if (!isAuthRoute) {
                <div class="dropdown shrink-0">
                    <div hlMenu class="!block">
                        <button type="button" hlMenuButton class="group relative block">
                            <span
                                class="w-8 h-8 sm:w-9 sm:h-9 bg-black dark:bg-white text-white dark:text-black rounded-full grid place-items-center text-sm uppercase">
                                {{ user?.firstName?.[0] }}{{ user?.lastName?.[0] }}
                            </span>
                        </button>
                        <ul *hlMenuItems @toggleAnimation
                            class="top-11 w-fit !py-0 font-semibold text-dark dark:text-white-dark dark:text-white-light/90 ltr:right-0 rtl:left-0">
                            <li>
                                <div class="flex items-center px-4 py-4">
                                    <div class="flex-none">
                                        <span
                                            class="w-10 h-10 bg-black dark:bg-white text-white dark:text-black rounded-sm grid place-items-center text-sm uppercase">
                                            {{ user?.firstName?.[0] }}{{ user?.lastName?.[0] }}
                                        </span>
                                    </div>
                                    <div class="truncate ltr:pl-4 rtl:pr-4">
                                        <h4 class="text-base">
                                            <span class="capitalize">{{ user?.firstName }} {{ user?.lastName }}</span>
                                        </h4>
                                        <a class="text-black/60 hover:text-primary dark:text-dark-light/60 dark:hover:text-white"
                                            href="javascript:;">
                                            <span>{{ user?.email }}</span>
                                        </a>
                                    </div>
                                </div>
                            </li>
                            <li class="border-t border-white-light dark:border-white-light/10 !flex !items-center !justify-center">
                                <button *hlMenuItem="let menuItem" class="!py-3 space-x-2 text-danger w-fit"
                                    (click)="logout()">
                                    <icon-logout />
                                    <span>{{ 'logout' | translate }}</span>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
                }
                } @else if (!isOnboardingRoute && !isAuthRoute) {
                <button type="button"
                    class="sm:hidden flex-none rounded-full bg-white-light/40 p-1.5 hover:bg-white-light/90 hover:text-primary dark:bg-dark/40 dark:text-[#d0d2d6] dark:hover:bg-dark/60 dark:hover:text-primary"
                    (click)="showMobileMenu = !showMobileMenu">
                    <icon-menu class="h-4 w-4 sm:h-5 sm:w-5" />
                </button>
                }

                @if ((user$ | async) && !isOnboardingRoute && !isAuthRoute) {
                <a href="javascript:;"
                    class="collapse-icon flex flex-none rounded-full bg-white-light/40 p-1.5 hover:bg-white-light/90 hover:text-primary dark:bg-dark/40 dark:text-[#d0d2d6] dark:hover:bg-dark/60 dark:hover:text-primary lg:hidden"
                    (click)="storeData.dispatch({type: 'toggleSidebar'})">
                    <icon-menu class="h-4 w-4 sm:h-5 sm:w-5" />
                </a>
                }
            </div>
        </div>

    @if (isOnboardingRoute && (onboardingTitleKey || onboardingTitle)) {
    <div class="bg-white px-3 sm:px-5 py-2 sm:py-3 dark:bg-[#0e1726]">
        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1.5 sm:gap-2">
            <div class="min-w-0 ltr:text-left rtl:text-right">
                @if (onboardingShowBack) {
                <button type="button" (click)="onboardingBackClick.emit()"
                    class="mb-0.5 inline-flex items-center gap-1.5 text-sm font-medium text-primary hover:underline">
                    <i class="ri-arrow-left-line"></i>
                    {{ 'back' | translate }}
                </button>
                }
                <h1 class="text-lg sm:text-2xl font-bold text-gray-900 dark:text-white leading-snug sm:leading-tight">
                    @if (onboardingTitleKey) {
                    {{ onboardingTitleKey | translate }}
                    } @else {
                    {{ onboardingTitle }}
                    }
                </h1>
                @if (onboardingStartDate) {
                <div class="mt-1 flex items-center justify-between gap-2 sm:block">
                    <p class="text-sm text-gray-600 dark:text-gray-400 min-w-0">
                        {{ 'onboarding.startedOn' | translate }} {{ onboardingStartDate | appDateFormat : '—' }}
                    </p>
                    @if (onboardingIsViewOnly || onboardingApplicationStatusName) {
                    <div class="flex shrink-0 items-center gap-2 sm:hidden">
                        <ng-container *ngTemplateOutlet="onboardingStatusBadges"></ng-container>
                    </div>
                    }
                </div>
                } @else if (onboardingIsViewOnly || onboardingApplicationStatusName) {
                <div class="mt-1 flex justify-end sm:hidden">
                    <ng-container *ngTemplateOutlet="onboardingStatusBadges"></ng-container>
                </div>
                }
            </div>

            @if (onboardingIsViewOnly || onboardingApplicationStatusName) {
            <div class="hidden sm:flex shrink-0 items-center gap-2">
                <ng-container *ngTemplateOutlet="onboardingStatusBadges"></ng-container>
            </div>
            }
        </div>
    </div>
    }

    <!-- horizontal menu -->
    <ul
        class="horizontal-menu hidden border-t border-[#ebedf2] bg-white px-6 py-1.5 font-semibold text-black dark:border-[#191e3a] dark:bg-[#0e1726] dark:text-white-dark lg:space-x-1.5 xl:space-x-8 rtl:space-x-reverse">
        @for (item of navMenuList; track item.label) {
        <li *appHasPermission="item.permission" class="menu nav-item relative">
            @if (!item.isDropdown) {
            <a routerLink="{{item.link}}" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                class="nav-link">
                <div class="flex items-center">
                    <ng-container *ngComponentOutlet="item.icon"></ng-container>
                    <span class="px-2">{{ item.label | translate }}</span>
                </div>
            </a>
            }
            @if (item.isDropdown) {
            <a href="javascript:;" class="nav-link">
                <div class="flex items-center">
                    <ng-container *ngComponentOutlet="item.icon"></ng-container>
                    <span class="px-2">{{ item.label | translate }}</span>
                </div>
                <div class="right_arrow">
                    <icon-caret-down />
                </div>
            </a>
            <ul class="sub-menu">
                @for (subItem of item.submenu; track subItem.label) {
                <li *appHasPermission="subItem.permission">
                    <a routerLink="{{subItem.link}}" routerLinkActive="active">{{ subItem.label | translate }}</a>
                </li>
                }
            </ul>
            }
        </li>
        }
    </ul>
</div>

<ng-template #onboardingHeaderLogo>
    <div class="flex items-center justify-start min-w-0 shrink ltr:mr-auto rtl:ml-auto">
        <a routerLink="/" class="main-logo flex shrink-0 items-center max-w-full">
            <img class="inline h-7 sm:h-9 w-auto max-w-[110px] sm:max-w-[180px] object-contain ltr:-ml-1 rtl:-mr-1" src="/assets/images/logo.svg" alt="" />
        </a>
    </div>
</ng-template>

<ng-template #onboardingStatusBadges>
    @if (onboardingIsViewOnly) {
    <span
        class="inline-flex items-center gap-1 px-2 py-1 bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300 text-sm rounded-lg">
        <i class="ri-eye-line"></i>
        {{ 'onboarding.viewOnly' | translate }}
    </span>
    }
    <span class="px-2 py-1 bg-gray-200 text-gray-700 dark:bg-gray-700 dark:text-gray-200 text-sm rounded-lg whitespace-nowrap">
        {{ (onboardingApplicationStatusName || 'Draft') | translate }}
    </span>
</ng-template>